import configureStore from "./configure_store";

export default configureStore();
